export const SITES_AREAS_EQS = "SITES_AREAS_EQS";
export const SITES_AREAS_EQS2 = "SITES_AREAS_EQS2";
export const CREATE_SITE = "CREATE_SITE";
export const CREATE_AREA = "CREATE_AREA";

export const CREATE_AREA_SHIFTS = "CREATE_AREA_SHIFTS";
export const UPDATE_AREA_SHIFTS = "UPDATE_AREA_SHIFTS";


export const CREATE_EQUIPMENT_POOL_MAP = "CREATE_EQUIPMENT_POOL_MAP";

export const ASSIGN_SAE = "ASSIGN_SAE";
export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const CREATE_GENERIC_ATTACHMENT = "CREATE_GENERIC_ATTACHMENT";

export const UPDATE_GENERIC_ATTACHMENT = "UPDATE_GENERIC_ATTACHMENT";

export const ALL_CATEGORIES = "ALL_CATEGORIES"
export const ADD_CATEGORY = "ADD_CATEGORY"

export const EDIT_CATEGORY = "EDIT_CATEGORY"
export const DELETE_CATEGORY = "DELETE_CATEGORY"


export const UPDATE_AREA = "UPDATE_AREA"
export const UPDATE_SITE = "UPDATE_SITE"


export const DELETE_SITE = "DELETE_SITE"
export const DELETE_AREA = "DELETE_AREA"

export const DELETE_GENERIC_ATTACHMENT = "DELETE_GENERIC_ATTACHMENT"

export const EQUIPMENT_TYPES="EQUIPMENT_TYPES"
export const SINGLE_EQUIPMENT_TYPE="SINGLE_EQUIPMENT_TYPE"

export const SET_SAEDATA="SET_SAEDATA"
export const BRANDS_TYPES_EQUIPMENTS="BRANDS_TYPES_EQUIPMENTS"

export const CREATE_EQUIPMENT_TYPE="CREATE_EQUIPMENT_TYPE"
export const EQUIPMENT_CLASSES="EQUIPMENT_CLASSES"
export const CREATE_BRAND="CREATE_BRAND"
export const UPDATE_BRAND="UPDATE_BRAND"
export const DELETE_BRAND="DELETE_BRAND"

export const CREATE_CLASS="CREATE_CLASS"
export const UPDATE_CLASS="UPDATE_CLASS"
export const DELETE_CLASS="DELETE_CLASS"

export const EQUIPMENT_STREAM="EQUIPMENT_STREAM"

export const ALL_SITES_AREAS_EQS="ALL_SITES_AREAS_EQS"

export const SITES_AREAS_EQS2_EMPTY = "SITES_AREAS_EQS2_EMPTY";



export const getsitesareaeqs = (data,op) => {
  return {
    type: SITES_AREAS_EQS,
    payload:data,
    optype:op
  };
};

export const getsitesareaeqs2 = (data,op) => {
  return {
    type: SITES_AREAS_EQS2,
    payload:data,
    optype:op
  };
};

export const setsitesareaeqs2Empty = (data,op) => {
  return {
    type: SITES_AREAS_EQS2_EMPTY,
    payload:[],
    optype:op
  };
};
export const getallsitesareaeqs = (data,op) => {
  return {
    type: ALL_SITES_AREAS_EQS,
    payload:data,
    optype:op
  };
};

export const createSite = data =>{
  return {
    type: CREATE_SITE,
    payload:data
  };
};

export const updateSite = data =>{
  return {
    type: UPDATE_SITE,
    payload:data
  };
};

export const deleteSite = data =>{
  return {
    type: DELETE_SITE,
    payload:data
  };
};

export const createArea = data =>{
  return {
    type: CREATE_AREA,
    payload:data
  };
};


export const createAreaShifts = data =>{
  return {
    type: CREATE_AREA_SHIFTS,
    payload:data
  };
};

export const updateAreaShifts = data =>{
  return {
    type: UPDATE_AREA_SHIFTS,
    payload:data
  };
};

export const createEqPoolMap = data =>{
  return {
    type: CREATE_EQUIPMENT_POOL_MAP,
    payload:data
  };
};




export const updateArea = data =>{
  return {
    type: UPDATE_AREA,
    payload:data
  };
};

export const deleteArea = data =>{
  return {
    type: DELETE_AREA,
    payload:data
  };
};

export const assignSAE = (data,op) =>{
  return {
    type: ASSIGN_SAE,
    payload:data,
    optype:op
  };
};

export const createGenericAttachment = (data,op) =>{
  return {
    type: CREATE_GENERIC_ATTACHMENT,
    payload:data,
    optype:op
  };
};

export const updateGenericAttachment = (data,op) =>{
  return {
    type: UPDATE_GENERIC_ATTACHMENT,
    payload:data,
    optype:op
  };
};

export const deleteGenericAttachment = (data) =>{
  return {
    type: DELETE_GENERIC_ATTACHMENT,
    payload:data
  };
};

export const RefreshToken = (data,op) =>{
  return {
    type: REFRESH_TOKEN,
    payload:data,
    optype:op
  };
};
export const CreateCategory = (data,op) =>{
  return {
    type: ADD_CATEGORY,
    payload:data,
    optype:op
  };
};
export const GetAllCategories = (data,op) =>{
  return {
    type: ALL_CATEGORIES,
    payload:data,
    optype:op
  };
};
export const EditCategory = (data,op) =>{
  return {
    type: EDIT_CATEGORY,
    payload:data,
    optype:op
  };
};
export const DeleteCategory = (data,op) =>{
  return {
    type: DELETE_CATEGORY,
    payload:data,
    optype:op
  };
};

export const CreateEquipmentType = (data) =>{
  return {
    type: CREATE_EQUIPMENT_TYPE,
    payload:data
  };
};

export const CreateBrand = (data) =>{
  return {
    type: CREATE_BRAND,
    payload:data
  };
};

export const UpdateBrand = (data) =>{
  return {
    type: UPDATE_BRAND,
    payload:data
  };
};

export const DeleteBrand = (data) =>{
  return {
    type: DELETE_BRAND,
    payload:data
  };
};


export const CreateClass = (data) =>{
  return {
    type: CREATE_CLASS,
    payload:data
  };
};

export const UpdateClass = (data) =>{
  return {
    type: UPDATE_CLASS,
    payload:data
  };
};

export const DeleteClass = (data) =>{
  return {
    type: DELETE_CLASS,
    payload:data
  };
};

export const GetEquipmentTypes = () =>{
  return {
    type: EQUIPMENT_TYPES
  };
};



export const GetSingleEquipmentType = (data) =>{
  return {
    type: SINGLE_EQUIPMENT_TYPE,
    payload:data
  };
};

export const SetSaeData = (data) =>{
  return {
    type: SET_SAEDATA,
    payload:data
  };
};

export const GetBrandsTypesEqs = () =>{
  return {
    type: BRANDS_TYPES_EQUIPMENTS
  };
};

export const GetEquipmentClasses = () =>{
  return {
    type: EQUIPMENT_CLASSES
  };
};

export const GetEquipmentStream = (data,op) =>{
  return {
    type: EQUIPMENT_STREAM,
    payload:data,
    optype:op
  };
};







